import Axios from '@/services/axios'
import msg from '@/common/msg'
import * as code from '@/common/code'

export default {
  getWarehouses () {
    return new Promise((resolve, reject) => {
      Axios.get(
        '/Warehouses',
        {},
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  createCheckoutSession (params) {
    return new Promise((resolve, reject) => {
      Axios.post(
        '/Warehouse/create-checkout-session',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  cancelCheckoutSession (params) {
    return new Promise((resolve, reject) => {
      Axios.post(
        '/Warehouse/cancel-checkout-session',
        params,
        response => {
          if (!response) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  cancelSubscription (params) {
    return new Promise((resolve, reject) => {
      Axios.post(
        '/Warehouse/cancel-subscription',
        params,
        response => {
          if (!response) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getWarehouseAmazonDescription () {
    return new Promise((resolve, reject) => {
      Axios.get(
        '/Warehouse/amazon/descriptions',
        {},
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getWarehouseIcon (params) {
    return new Promise((resolve, reject) => {
      Axios.get(
        '/Warehouse/get-warehouse-icons',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getCurrentPlan () {
    return new Promise((resolve, reject) => {
      Axios.get(
        '/Warehouse/get-current-plan',
        {},
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getLogiInvoices () {
    return new Promise((resolve, reject) => {
      Axios.get(
        '/Warehouse/get-logi-invoices',
        {},
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  createCustomerPortalSession (params) {
    return new Promise((resolve, reject) => {
      Axios.get(
        '/Warehouse/create-customer-portal-session',
        params,
        response => {
          if (!response || !response.data || !response.data.records) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  regisScWarehouse () {
    return new Promise((resolve, reject) => {
      Axios.post(
        '/Warehouse/regis-sc-warehouse',
        {},
        response => {
          if (!response) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  },

  stopScWarehouse () {
    return new Promise((resolve, reject) => {
      Axios.post(
        '/Warehouse/stop-sc-warehouse',
        {},
        response => {
          if (!response) {
            reject(msg.serverErr)
          }
          if (response.data.header.resultCode !== code.success) {
            reject(response.data.header.message)
          }
          resolve(response.data.records)
        },
        error => {
          reject(error)
        }
      )
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/warehouseservice.js